import moment from 'moment';

class LaborRateModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope, $timeout) {
    "ngInject";
    this.name = 'LaborRateModal';

    $scope.errorMessage = '';
    $scope.subcontractMode = !!$uibModalInstance.subcontractMode;
    $scope.subcontractorShortName = $uibModalInstance.subcontractorShortName || '';
    $scope.enhancedForm = $scope.subcontractMode || !!$uibModalInstance.costBased;

    $scope.laborRate = {
      contractId: $scope.subcontractMode ? null : $uibModalInstance.contractId,
      subcontractId: $scope.subcontractMode ? $uibModalInstance.subcontractId : null
    };

    $scope.formState = {
      selectedFixedFeeBasis: null,
      selectedProject: null,
      selectedUser: null,
      createChargeCode: false,
      chargeCodeName: '',
      chargeCodeNameExists: false
    };

    $scope.indirectRates = [];
    $scope.availableIndirectRates = [];
    $scope.projects = [];
    $scope.fixedFeeBasisOptions = [];
    $scope.activeUsers = [];

    $scope.costBased = $uibModalInstance.costBased;
    $scope.laborCategories = $uibModalInstance.laborCategories;
    $scope.fixedFeeBasisList = $uibModalInstance.fixedFeeBasisList || [];
    $scope.selectedPeriodOfPerformance = $uibModalInstance.selectedPeriodOfPerformance || null;
    $scope.contract = $uibModalInstance.contract || null;
    $scope.customer = $uibModalInstance.customer || null;

    const projectContractId = $uibModalInstance.primeContractId || $uibModalInstance.contractId;

    $scope.formatFixedFeeBasisOption = $uibModalInstance.formatFixedFeeBasisOption || function (basis) {
      let label = (basis.modLabel || 'Basis') + ' — effective ' + moment(basis.effectiveDate).format('MMM DD, YYYY');
      if (basis.expirationDate) {
        label += ' – ' + moment(basis.expirationDate).format('MMM DD, YYYY');
      }
      return label;
    };

    $scope.formatIndirectRateOption = function (rate) {
      const start = rate.startDate ? moment(rate.startDate).format('MMM DD, YYYY') : '—';
      const end = rate.endDate ? moment(rate.endDate).format('MMM DD, YYYY') : 'open';
      return rate.name + ' (' + start + ' – ' + end + ')';
    };

    $scope.indirectRateOverlapsSelectedPop = function (rate) {
      const pop = $scope.selectedPeriodOfPerformance;
      if (!pop || !pop.startDate || !pop.endDate || !rate || !rate.startDate) {
        return false;
      }

      const popStart = moment(pop.startDate).startOf('day');
      const popEnd = moment(pop.endDate).startOf('day');
      const rateStart = moment(rate.startDate).startOf('day');
      const rateEnd = rate.endDate
        ? moment(rate.endDate).startOf('day')
        : moment('9999-12-31');

      if (!popStart.isValid() || !popEnd.isValid() || !rateStart.isValid() || !rateEnd.isValid()) {
        return false;
      }

      return rateStart.isSameOrBefore(popEnd) && popStart.isSameOrBefore(rateEnd);
    };

    $scope.refreshAvailableIndirectRates = function () {
      $scope.availableIndirectRates = ($scope.indirectRates || []).filter(function (rate) {
        if (!$scope.selectedPeriodOfPerformance) {
          return true;
        }
        return $scope.indirectRateOverlapsSelectedPop(rate);
      });

      if (!$scope.costBased || $scope.subcontractMode) {
        return;
      }

      const selected = $scope.laborRate.indirectRate;
      const selectedStillValid = selected && $scope.availableIndirectRates.some(function (rate) {
        return rate.id === selected.id;
      });
      if (selectedStillValid) {
        return;
      }

      const currentRate = $scope.availableIndirectRates.find(function (rate) {
        return rate.current;
      });
      $scope.laborRate.indirectRate = currentRate || ($scope.availableIndirectRates.length ? $scope.availableIndirectRates[0] : null);
    };

    if ($scope.subcontractMode && $uibModalInstance.subcontractorId) {
      $http.get($rootScope.apiHost + '/api/admin/subcontractors/' + $uibModalInstance.subcontractorId + '/employees', { withCredentials: true })
        .then(function (success) {
          $scope.activeUsers = (success.data || []).map(function (user) {
            if (!user.fullName) {
              user.fullName = ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
            }
            return user;
          });
        });
    } else {
      $http.get($rootScope.apiHost + '/api/admin/users/names', { withCredentials: true }).then(function (success) {
        $scope.activeUsers = success.data;
      });
    }

    if ($scope.costBased && !$scope.subcontractMode) {
      $http.get($rootScope.apiHost + '/api/admin/companies/1/indirectrates', { withCredentials: true }).then(function (success) {
        $scope.indirectRates = success.data || [];
        $scope.refreshAvailableIndirectRates();
      });
    }

    if ($scope.enhancedForm && projectContractId) {
      $http.get($rootScope.apiHost + '/api/admin/projects/bycontract?contract=' + projectContractId, { withCredentials: true })
        .then(function (success) {
          $scope.projects = success.data || [];
        });
    }

    $scope.refreshFixedFeeBasisOptions = function () {
      if (!$scope.selectedPeriodOfPerformance || !$scope.laborRate.laborCategory || !$scope.laborRate.laborCategory.id) {
        $scope.fixedFeeBasisOptions = [];
        return;
      }

      const popId = $scope.selectedPeriodOfPerformance.id;
      const laborCategoryId = $scope.laborRate.laborCategory.id;
      $scope.fixedFeeBasisOptions = ($scope.fixedFeeBasisList || []).filter(function (basis) {
        return Number(basis.periodOfPerformanceId) === Number(popId)
          && Number(basis.laborCategoryId) === Number(laborCategoryId);
      });
    };

    $scope.hasFixedFeeBasisForSelectedCategory = function () {
      return ($scope.fixedFeeBasisOptions || []).length > 0;
    };

    $scope.getFixedFeeBasisCountForLaborCategory = function () {
      const laborCategoryId = $scope.laborRate.laborCategory && $scope.laborRate.laborCategory.id;
      if (!laborCategoryId) {
        return 0;
      }

      const popId = $scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.id;
      return ($scope.fixedFeeBasisList || []).filter(function (basis) {
        if (Number(basis.laborCategoryId) !== Number(laborCategoryId)) {
          return false;
        }
        if (popId) {
          return Number(basis.periodOfPerformanceId) === Number(popId);
        }
        return true;
      }).length;
    };

    $scope.getProjectLabel = function (project) {
      if (!project) {
        return '';
      }
      const number = project.number || project.name || project.id;
      return number + ' — ' + (project.name || '');
    };

    $scope.buildSuggestedChargeCodeName = function () {
      if (!$scope.formState.selectedProject || !$scope.formState.selectedProject.id) {
        return '';
      }

      const customerShort = ($scope.customer && $scope.customer.shortName) || 'CUST';
      const taskOrderNumber = $scope.formState.selectedProject.number
        || $scope.formState.selectedProject.shortName
        || $scope.formState.selectedProject.name;
      const lcatShort = ($scope.laborRate.laborCategory && $scope.laborRate.laborCategory.shortName)
        || ($scope.laborRate.laborCategory && $scope.laborRate.laborCategory.name)
        || 'LCAT';
      const optionYear = ($scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.name) || 'OY';
      const feeBasisCount = $scope.getFixedFeeBasisCountForLaborCategory();

      const parts = [customerShort, taskOrderNumber];
      if ($scope.subcontractMode) {
        parts.push($scope.subcontractorShortName || 'SUB');
      }
      parts.push(lcatShort, optionYear, feeBasisCount);

      return parts.join('-').replace(/\s+/g, '_');
    };

    $scope.buildSuggestedChargeCodeDescription = function () {
      const lcatName = ($scope.laborRate.laborCategory && $scope.laborRate.laborCategory.name) || 'labor category';
      const contractName = ($scope.contract && ($scope.contract.contractName || $scope.contract.name)) || 'contract';
      const projectName = ($scope.formState.selectedProject && $scope.formState.selectedProject.name) || 'project';
      const popName = ($scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.name) || 'period of performance';
      return 'This is a charge code for a ' + lcatName + ' on the ' + contractName
        + ' contract in support of the ' + projectName + ' project. This charge code is for the '
        + popName + ' period of performance.';
    };

    let nameCheckTimeout = null;
    $scope.checkChargeCodeName = function () {
      $scope.formState.chargeCodeNameExists = false;
      if (!$scope.formState.chargeCodeName || !$scope.formState.chargeCodeName.trim()) {
        return;
      }

      if (nameCheckTimeout) {
        $timeout.cancel(nameCheckTimeout);
      }

      nameCheckTimeout = $timeout(function () {
        $http.get($rootScope.apiHost + '/api/admin/chargecodes/name/' + encodeURIComponent($scope.formState.chargeCodeName.trim()), { withCredentials: true })
          .then(function () {
            $scope.formState.chargeCodeNameExists = true;
          }, function () {
            $scope.formState.chargeCodeNameExists = false;
          });
      }, 300);
    };

    $scope.refreshSuggestedChargeCodeName = function () {
      if (!$scope.formState.createChargeCode) {
        return;
      }

      if (!$scope.formState.selectedProject || !$scope.formState.selectedProject.id) {
        $scope.formState.chargeCodeName = '';
        $scope.formState.chargeCodeNameExists = false;
        return;
      }

      $scope.formState.chargeCodeName = $scope.buildSuggestedChargeCodeName();
      $scope.checkChargeCodeName();
    };

    $scope.onProjectSelected = function () {
      $scope.refreshSuggestedChargeCodeName();
    };

    $scope.onFixedFeeBasisSelected = function () {
      $scope.refreshLaborRateName();
    };

    $scope.formatEmployeeNameForLaborRate = function (user) {
      if (!user) {
        return '';
      }
      const firstName = (user.firstName || '').trim();
      const lastName = (user.lastName || '').trim();
      if (firstName && lastName) {
        return firstName.charAt(0).toUpperCase() + lastName;
      }
      if (user.fullName) {
        return user.fullName;
      }
      return '';
    };

    $scope.formatFixedFeeBasisDateForLaborRate = function (basis) {
      if (!basis || !basis.effectiveDate) {
        return '';
      }

      const start = moment(basis.effectiveDate).format('MM/DD/YY');
      const endSource = basis.expirationDate
        || ($scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.endDate);
      if (!endSource) {
        return start;
      }
      return start + '-' + moment(endSource).format('MM/DD/YY');
    };

    $scope.buildSuggestedLaborRateName = function () {
      if (!$scope.enhancedForm) {
        return $scope.laborRate.name || '';
      }

      const parts = [];
      if ($scope.laborRate.laborCategory && $scope.laborRate.laborCategory.name) {
        parts.push($scope.laborRate.laborCategory.name);
      }

      const employeeName = $scope.formatEmployeeNameForLaborRate($scope.formState.selectedUser);
      if (employeeName) {
        parts.push(employeeName);
      }

      const dateRange = $scope.formatFixedFeeBasisDateForLaborRate($scope.formState.selectedFixedFeeBasis);
      if (dateRange) {
        parts.push(dateRange);
      } else if ($scope.selectedPeriodOfPerformance && $scope.selectedPeriodOfPerformance.startDate) {
        const start = moment($scope.selectedPeriodOfPerformance.startDate).format('MM/DD/YY');
        const end = $scope.selectedPeriodOfPerformance.endDate
          ? moment($scope.selectedPeriodOfPerformance.endDate).format('MM/DD/YY')
          : '';
        parts.push(end ? (start + '-' + end) : start);
      }

      return parts.join(' ');
    };

    $scope.refreshLaborRateName = function () {
      if (!$scope.enhancedForm) {
        return;
      }
      $scope.laborRate.name = $scope.buildSuggestedLaborRateName();
    };

    $scope.$watch(function () {
      return $scope.laborRate.laborCategory && $scope.laborRate.laborCategory.id;
    }, function () {
      $scope.formState.selectedFixedFeeBasis = null;
      $scope.refreshFixedFeeBasisOptions();
      $scope.refreshLaborRateName();
      $scope.refreshSuggestedChargeCodeName();
    });

    $scope.$watch('formState.createChargeCode', function (enabled) {
      if (enabled) {
        $scope.refreshSuggestedChargeCodeName();
      } else {
        $scope.formState.selectedProject = null;
        $scope.formState.chargeCodeName = '';
        $scope.formState.chargeCodeNameExists = false;
      }
    });

    $scope.cancel = function () {
      $scope.laborRate = {};
      $uibModalInstance.dismiss('cancel');
    };

    $scope.selectUser = function (user) {
      $scope.formState.selectedUser = user;
      $scope.laborRate.userId = user && user.id;
      $scope.refreshLaborRateName();
    };

    $scope.getValidationMessage = function () {
      if (!$scope.laborRate.laborCategory) {
        return 'Select a labor category.';
      }
      if (!$scope.enhancedForm) {
        if (!$scope.laborRate.name) {
          return 'Enter a labor rate name.';
        }
        return '';
      }
      if (!$scope.laborRate.userId && !($scope.formState.selectedUser && $scope.formState.selectedUser.id)) {
        return 'Select an employee.';
      }
      if (!$scope.subcontractMode) {
        if (!$scope.laborRate.indirectRate || !$scope.laborRate.indirectRate.id) {
          return 'Select an indirect rate.';
        }
      }
      if ($scope.costBased) {
        if (!$scope.hasFixedFeeBasisForSelectedCategory()) {
          return 'Add a fixed fee basis for this labor category before creating a labor rate.';
        }
        if (!$scope.formState.selectedFixedFeeBasis || !$scope.formState.selectedFixedFeeBasis.id) {
          return 'Select a fixed fee basis.';
        }
      }
      if ($scope.formState.createChargeCode) {
        if (!$scope.formState.selectedProject || !$scope.formState.selectedProject.id) {
          return 'Select a project for the charge code.';
        }
        if (!$scope.formState.chargeCodeName || !$scope.formState.chargeCodeName.trim()) {
          return 'Enter a charge code name.';
        }
        if ($scope.formState.chargeCodeNameExists) {
          return 'A charge code with this name already exists.';
        }
      }
      if (!$scope.laborRate.name) {
        return 'Enter a labor rate name.';
      }
      return '';
    };

    $scope.addLaborRate = function () {
      $scope.errorMessage = '';

      if (!$scope.laborRate.userId && $scope.formState.selectedUser && $scope.formState.selectedUser.id) {
        $scope.laborRate.userId = $scope.formState.selectedUser.id;
      }

      const validationMessage = $scope.getValidationMessage();
      if (validationMessage) {
        $scope.errorMessage = validationMessage;
        return;
      }

      if ($scope.costBased && $scope.selectedPeriodOfPerformance && $scope.formState.selectedFixedFeeBasis) {
        $scope.laborRate.popRateFixedFeeBasisByPopId = {};
        $scope.laborRate.popRateFixedFeeBasisByPopId[$scope.selectedPeriodOfPerformance.id] = $scope.formState.selectedFixedFeeBasis.id;
      }

      if ($scope.enhancedForm && $scope.formState.createChargeCode) {
        $scope.laborRate.createChargeCodeRequest = {
          projectId: $scope.formState.selectedProject.id,
          name: $scope.formState.chargeCodeName.trim(),
          description: $scope.buildSuggestedChargeCodeDescription(),
          periodOfPerformanceId: $scope.selectedPeriodOfPerformance.id,
          userId: $scope.laborRate.userId
        };
      } else {
        delete $scope.laborRate.createChargeCodeRequest;
      }

      if ($scope.subcontractMode) {
        delete $scope.laborRate.indirectRate;
        $scope.laborRate.directRate = false;
      }

      $uibModalInstance.success($scope.laborRate);
    };
  }
}

export default LaborRateModalController;



// WEBPACK FOOTER //
// ./client/common/modals/laborRateModal/laborRateModal.controller.js